import { fetchCurrentUser } from '../../ducks/user.duck';
import {
  getPublishedDiscoverGroupsCarouselsApi,
  searchGroupsApi,
  searchSpaceGroupsApi,
} from '../../util/api';
import { EXPLORE } from '../../util/types';
import { parse } from '../../util/urlHelpers';
import {
  fetchSpaceList,
  getCurrentUserCircleAuthParams,
  setActiveTab,
  setInitalLoadToken
} from '../CircleCommunityPage/CircleCommunityPage.duck';

export const REQUEST_SEARCH_GROUPS = 'app/GroupSearchPage/REQUEST_SEARCH_GROUPS';
export const SUCCESS_SEARCH_GROUPS = 'app/GroupSearchPage/SUCCESS_SEARCH_GROUPS';
export const ERROR_SEARCH_GROUPS = 'app/GroupSearchPage/ERROR_SEARCH_GROUPS';
export const REQUEST_SPACE_GROUPS = 'app/GroupSearchPage/REQUEST_SPACE_GROUPS';
export const SUCCESS_SPACE_GROUPS = 'app/GroupSearchPage/SUCCESS_SPACE_GROUPS';
export const ERROR_SPACE_GROUPS = 'app/GroupSearchPage/ERROR_SPACE_GROUPS';
export const REQUEST_ACCESS_TOKEN = 'app/GroupSearchPage/REQUEST_ACCESS_TOKEN';
export const SUCCESS_ACCESS_TOKEN = 'app/GroupSearchPage/SUCCESS_ACCESS_TOKEN';
export const ERROR_ACCESS_TOKEN = 'app/GroupSearchPage/ERROR_ACCESS_TOKEN';
export const REQUEST_DISCOVER_GROUPS_CAROUSELS =
  'app/GroupSearchPage/REQUEST_DISCOVER_GROUPS_CAROUSELS';
export const SUCCESS_DISCOVER_GROUPS_CAROUSELS =
  'app/GroupSearchPage/SUCCESS_DISCOVER_GROUPS_CAROUSELS';
export const ERROR_DISCOVER_GROUPS_CAROUSELS =
  'app/GroupSearchPage/ERROR_DISCOVER_GROUPS_CAROUSELS';

const searchGroupsRequests = new Map();

const getSearchGroupsRequestKey = params => {
  const { page = 1, sort = '', keyword = '', space_group = '' } = params || {};
  return [
    Number(page) || 1,
    String(sort || '').trim(),
    String(keyword || '').trim().toLowerCase(),
    String(space_group || '').trim(),
  ].join(':');
};

const initialState = {
  requestSearchGroups: false,
  searchGroupsData: null,
  errorSearchGroups: null,
  requestSpaceGroups: false,
  spaceGroupsData: null,
  errorSpaceGroups: null,
  loadMoreSearchGroups: false,
  requestAccessToken: false,
  accessToken: null,
  errorAccessToken: null,
  requestDiscoverGroupsCarousels: false,
  discoverGroupsCarousels: [],
  errorDiscoverGroupsCarousels: null,
};

export default function groupSearchPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case REQUEST_SEARCH_GROUPS:
      return {
        ...state,
        requestSearchGroups: payload.page <= 1,
        loadMoreSearchGroups: payload.page > 1,
        //searchGroupsData: payload
      };
    case SUCCESS_SEARCH_GROUPS:
      const { data } = payload;
      const { page, records } = data;
      return {
        ...state,
        requestSearchGroups: false,
        loadMoreSearchGroups: false,
        searchGroupsData: {
          ...data,
          records: page > 1 ? [...state.searchGroupsData.records, ...records] : records,
        },
      };
    case ERROR_SEARCH_GROUPS:
      return {
        ...state,
        requestSearchGroups: false,
        loadMoreSearchGroups: false,
        searchGroupsData: null,
        errorSearchGroups: payload.error,
      };
    case REQUEST_SPACE_GROUPS:
      return { ...state, requestSpaceGroups: true };
    case SUCCESS_SPACE_GROUPS:
      return { ...state, requestSpaceGroups: false, spaceGroupsData: payload.data };
    case ERROR_SPACE_GROUPS:
      return {
        ...state,
        requestSpaceGroups: false,
        spaceGroupsData: null,
        errorSpaceGroups: payload.error,
      };
    case REQUEST_ACCESS_TOKEN:
      return { ...state, requestAccessToken: true };
    case SUCCESS_ACCESS_TOKEN:
      return { ...state, requestAccessToken: false, accessToken: payload.data };
    case ERROR_ACCESS_TOKEN:
      return {
        ...state,
        requestAccessToken: false,
        accessToken: null,
        errorAccessToken: payload.error,
      };
    case REQUEST_DISCOVER_GROUPS_CAROUSELS:
      return { ...state, requestDiscoverGroupsCarousels: true, errorDiscoverGroupsCarousels: null };
    case SUCCESS_DISCOVER_GROUPS_CAROUSELS:
      return {
        ...state,
        requestDiscoverGroupsCarousels: false,
        discoverGroupsCarousels: payload.data || [],
      };
    case ERROR_DISCOVER_GROUPS_CAROUSELS:
      return {
        ...state,
        requestDiscoverGroupsCarousels: false,
        discoverGroupsCarousels: [],
        errorDiscoverGroupsCarousels: payload.error,
      };
    default:
      return state;
  }
}

export const requestSearchGroups = (page) => ({
  type: REQUEST_SEARCH_GROUPS,
  payload: { page },
});
export const successSearchGroups = data => ({
  type: SUCCESS_SEARCH_GROUPS,
  payload: { data },
});
export const errorSearchGroups = error => ({
  type: ERROR_SEARCH_GROUPS,
  payload: { error },
});

export const requestSpaceGroups = () => ({
  type: REQUEST_SPACE_GROUPS,
});
export const successSpaceGroups = data => ({
  type: SUCCESS_SPACE_GROUPS,
  payload: { data },
});
export const errorSpaceGroups = error => ({
  type: ERROR_SPACE_GROUPS,
  payload: { error },
});

export const requestAccessToken = () => ({
  type: REQUEST_ACCESS_TOKEN,
});
export const successAccessToken = data => ({
  type: SUCCESS_ACCESS_TOKEN,
  payload: { data },
});
export const errorAccessToken = error => ({
  type: ERROR_ACCESS_TOKEN,
  payload: { error },
});

export const fetchDiscoverGroupsCarousels = () => async dispatch => {
  try {
    dispatch({ type: REQUEST_DISCOVER_GROUPS_CAROUSELS });
    const response = await getPublishedDiscoverGroupsCarouselsApi();
    const data = Array.isArray(response?.data) ? response.data : [];
    dispatch({ type: SUCCESS_DISCOVER_GROUPS_CAROUSELS, payload: { data } });
    return data;
  } catch (error) {
    dispatch({ type: ERROR_DISCOVER_GROUPS_CAROUSELS, payload: { error } });
    return [];
  }
};

export const searchGroups = params => async (dispatch, getState, sdk) => {
  const { page = 1, sort = '', keyword = '', space_group = '' } = params;
  const requestKey = getSearchGroupsRequestKey({ page, sort, keyword, space_group });

  if (searchGroupsRequests.has(requestKey)) {
    return searchGroupsRequests.get(requestKey);
  }

  try {
    dispatch(requestSearchGroups(page));
    // dispatch(successAccessToken(access_token ?? {success, message}));
    const request = searchGroupsApi({
      accessToken: "access_token",
      page: page,
      sort: sort,
      keyword,
      type: 'spaces',
      space_group,
    }).finally(() => {
      searchGroupsRequests.delete(requestKey);
    });

    searchGroupsRequests.set(requestKey, request);
    const response = await request;
    dispatch(successSearchGroups({ ...response, sort, keyword }));
    return response;
  } catch (e) {
    searchGroupsRequests.delete(requestKey);
    console.log(e, '&&& &&& => e');
  }
};

export const searchSpaceGroups = params => async (dispatch, getState, sdk) => {
  try {
    dispatch(requestSpaceGroups());
    const response = await searchSpaceGroupsApi({
      accessToken: "access_token"
    })
    dispatch(successSpaceGroups(response));
    return response
  } catch (error) {
    console.log(error, '&&& &&& => error');
    dispatch(errorSpaceGroups(error))
  }
}

export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
  const { page = 1, sort = 'latest', keyword = '', space_group = '' } = parse(search);
  dispatch(requestSearchGroups(page));

  try {
    dispatch(fetchCurrentUser())
      .then(async () => {
        // Get the current user's data from state
        const currentUser = getState()?.user?.currentUser;
        const email = currentUser?.attributes?.email;
        if (email) {
          // fetch auth token on first load
          await setInitalLoadToken(getCurrentUserCircleAuthParams(currentUser));
          dispatch(fetchSpaceList({ page: 1, limit: 1000 }));
        }
      })
      .catch((e) => {
        console.log(e, '&&& &&& => e');
      })
  } catch (error) {
    console.log(error, '&&& &&& => error');
  }

  const searchGropProps = {
    page: +page,
    ...(sort ? { sort } : {}),
    ...(keyword ? { keyword: keyword } : {}),
    ...(space_group ? { space_group } : {}),
  }

  return Promise.all([
    dispatch(searchGroups(searchGropProps)),
    dispatch(searchSpaceGroups()),
    dispatch(fetchDiscoverGroupsCarousels()),
    dispatch(setActiveTab(EXPLORE))
  ])
    .then(async response => {
      return response;
    })
    .catch(e => {
      throw e;
    });
};
